import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerPhone } from 'common/customers/services/types/RsCustomerPhone';
import { RsCustomerPhoneInfo } from 'common/customers/services/types/RsCustomerPhoneInfo';
import { CustomerPhoneAdd } from 'common/customers/services/types/CustomerPhoneAdd';
import { CustomerPhoneUpdate } from 'common/customers/services/types/CustomerPhoneUpdate';
import { CustomerPhonePatch } from 'common/customers/services/types/CustomerPhonePatch';

export interface ICustomerPhoneDataProvider
    extends IDataProviderV2<RsCustomerPhone, RsCustomerPhoneInfo, CustomerPhoneAdd, CustomerPhoneUpdate, CustomerPhonePatch> {
    getMainForSms: (number) => Promise<RsCustomerPhone>;
}

@A9Service('customerPhoneDataProvider')
export class CustomerPhoneDataProvider
    extends AbstractDataProviderV2<RsCustomerPhone, RsCustomerPhoneInfo, CustomerPhoneAdd, CustomerPhoneUpdate, CustomerPhonePatch>
    implements ICustomerPhoneDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/phones');
    }

    public getMainForSms(customerId: number) {
        return this.all({}, { customerId: customerId }).then(items => {
            return items.find(item => item.active && item.mainForSms);
        });
    }
}
